// eslint-disable-next-line import/no-anonymous-default-export
export default {
  "chatServer": "wss://chat.fastballs.elbet.com:8765",
  "gameServers": ["https://server.fastballs.elbet.com:9334"]
}